import axios from "./axios";
import parseError from "../../Utils/ErrorParse";
import { getJourneyHeaders } from "../../Utils/journeyHeaders";
import { applyTenantScopeHeaders } from "../../context/platformAdminContext.utils";
// import { USER_ROLE } from "../../Constants/constant";

function withAPIKeys(requestConfig) {
  const token = localStorage.getItem("accessToken");
  let headers = {
    ...requestConfig?.headers,
  };
  applyTenantScopeHeaders(headers);
  Object.assign(headers, getJourneyHeaders());
  if (token && requestConfig.isAuthToken !== false) {
    delete requestConfig.isAuthToken;
    // console.log("requestConfig", requestConfig);
    return {
      ...requestConfig,
      headers: {
        ...headers,
        accept: "application/json",
        Authorization: `Bearer ${token}` ?? "A",
      },
    };
  }
  delete requestConfig.isAuthToken;
  // console.log("requestConfig", requestConfig);
  return {
    ...requestConfig,
    headers: {
      ...headers,
      "Content-Type": "application/json",
    },
  };
}

function withMultipartAPIKeys(requestConfig) {
  const token = localStorage.getItem("accessToken");
  const headers = {
    ...requestConfig?.headers,
  };
  applyTenantScopeHeaders(headers);
  Object.assign(headers, getJourneyHeaders());
  if (token) {
    headers["Authorization"] = `Bearer ${token}` ?? "A";
  }
  // Do NOT set Content-Type when sending FormData – axios will set
  // multipart/form-data with the correct boundary automatically.
  return {
    ...requestConfig,
    headers,
  };
}

const addPageNumber = (url, params, skipQueryParams) => {
  params = params ?? {};
  let str = "";
  if (params.page) {
    str = `${url.includes("?") ? "&" : ""}page=${params.page}`;
  }
  if (params.per_page) {
    str = `${str}${str ? "&" : ""}per_page=${params.per_page}`;
  }
  if (params.search) {
    str = `${str}${str ? "&" : ""}search=${encodeURIComponent(params.search)}`;
  }
  if (params.search_contact) {
    str = `${str}${str ? "&" : ""}search_contact=1`;
  }
  if (params.sort_order) {
    str = `${str}${str ? "&" : ""}sort_order=${params.sort_order}`;
  }
  if (params.sort_field) {
    str = `${str}${str ? "&" : ""}sort_field=${params.sort_field}`;
  }

  if (skipQueryParams) {
    if (!str) return url;
    // URL may already include a query string; do not insert a second "?".
    return url.includes("?") ? `${url}${str}` : `${url}?${str}`;
  }

  if (params.status) {
    str = `${str}${str ? "&" : ""}status=${params.status}`;
  }
  if (params.type) {
    str = `${str}${str ? "&" : ""}type=${params.type}`;
  }
  if (params.participant_uuid) {
    str = `${str}${str ? "&" : ""}participant_uuid=${params.participant_uuid}`;
  }
  if (params.participant_name) {
    str = `${str}${str ? "&" : ""}participant_name=${params.participant_name}`;
  }
  if (params.opt_in_status) {
    str = `${str}${str ? "&" : ""}opt_in_status=${params.opt_in_status}`;
  }
  if (params.region_id) {
    str = `${str}${str ? "&" : ""}region_id=${params.region_id}`;
  }
  if (params.manager) {
    str = `${str}${str ? "&" : ""}manager=${params.manager}`;
  }
  if (params.manager_email) {
    str = `${str}${str ? "&" : ""}manager_email=${params.manager_email}`;
  }
  if (params.manager_uuid) {
    str = `${str}${str ? "&" : ""}manager_uuid=${params.manager_uuid}`;
  }
    if (params.worker_uuid) {
    str = `${str}${str ? "&" : ""}worker_uuid=${params.worker_uuid}`;
  }
  if (params.date_range) {
    str = `${str}${str ? "&" : ""}date_range=${params.date_range}`;
  }
  if (params.date_from) {
    str = `${str}${str ? "&" : ""}date_from=${params.date_from}`;
  }
  if (params.date_to) {
    str = `${str}${str ? "&" : ""}date_to=${params.date_to}`;
  }
  if (params.filter) {
    str = `${str}${str ? "&" : ""}filter=${JSON.stringify(params.filter)}`;
  }
  if (params.id) {
    str = `${str}${str ? "&" : ""}id=${params.id}`;
  }
  if (params.role_id != null && params.role_id !== "") {
    str = `${str}${str ? "&" : ""}role_id=${params.role_id}`;
  }
  if (params.pt_id != null && params.pt_id !== "") {
    // Arrays must stay in the POST/PATCH JSON body only. Appending them to the
    // query string comma-joins UUIDs (pt_id=a,b), which overrides the body in
    // Laravel and breaks is_array($pt_id) — so open/group create only ever
    // loads the first participant's tasks (V360-5369).
    if (!Array.isArray(params.pt_id)) {
      str = `${str}${str ? "&" : ""}pt_id=${encodeURIComponent(params.pt_id)}`;
    }
  }
  /** Participant profile funding list: must be forwarded or expired fundings stay filtered server-side */
  if (Object.prototype.hasOwnProperty.call(params, "include_expired")) {
    str = `${str}${str ? "&" : ""}include_expired=${
      params.include_expired ? 1 : 0
    }`;
  }
  if (params.c_id) {
    str = `${str}${str ? "&" : ""}c_id=${params.c_id}`;
  }
  if (params.version_id) {
    str = `${str}${str ? "&" : ""}version_id=${params.version_id}`;
  }
  if (params.state_id) {
    str = `${str}${str ? "&" : ""}state_id=${params.state_id}`;
  }
  if (params.funding_uuid) {
    str = `${str}${str ? "&" : ""}funding_uuid=${params.funding_uuid}`;
  }
  if (params.funding_id) {
    str = `${str}${str ? "&" : ""}funding_id=${params.funding_id}`;
  }
  if (params.plan_budget_id) {
    str = `${str}${str ? "&" : ""}id=${params.plan_budget_id}`;
  }
  if (params.plan_budget_uuid) {
    str = `${str}${str ? "&" : ""}plan_budget_uuid=${params.plan_budget_uuid}`;
  }
  if (params.funding_reference_id) {
    str = `${str}${str ? "&" : ""}funding_reference_id=${
      params.funding_reference_id
    }`;
  }
  if (params.sc_id) {
    str = `${str}${str ? "&" : ""}sc_id=${params.sc_id}`;
  }
  if (params.plan_budget_uuid) {
    str = `${str}${str ? "&" : ""}plan_budget_uuid=${params.plan_budget_uuid}`;
  }
  if (params.support_item_number) {
    str = `${str}${str ? "&" : ""}support_item_number=${
      params.support_item_number
    }`;
  }
  if (params.reporting_pdf) {
    str = `${str}${str ? "&" : ""}reporting_pdf=${
      params.reporting_pdf
    }`;
  }
  if (params.entity_type) {
    str = `${str}${str ? "&" : ""}entity_type=${params.entity_type}`;
  }
  if (params.action) {
    str = `${str}${str ? "&" : ""}action=${params.action}`;
  }
  if (params.user_id) {
    str = `${str}${str ? "&" : ""}user_id=${params.user_id}`;
  }
  if (params.from) {
    str = `${str}${str ? "&" : ""}from=${params.from}`;
  }
  if (params.to) {
    str = `${str}${str ? "&" : ""}to=${params.to}`;
  }
  if (params.profile_uuid) {
    str = `${str}${str ? "&" : ""}profile_uuid=${encodeURIComponent(params.profile_uuid)}`;
  }
  if (params.since_id) {
    str = `${str}${str ? "&" : ""}since_id=${params.since_id}`;
  }

  // if (params.hasOwnProperty("filter")) {
  //   str = `${str}${str ? "&" : ""}filter=${JSON.stringify(params.filter)}`;
  // }
  return str ? `${url}${url.includes("?") ? "" : "?"}${str}` : url;
};

/** Optional AbortSignal support — additive; callers without signal are unchanged. */
const withOptionalSignal = (payload, requestConfig) => {
  if (payload?.signal) {
    return { ...requestConfig, signal: payload.signal };
  }
  return requestConfig;
};

export const apiCall = {
  get: (payload) =>
    axios
      .get(
        addPageNumber(
          // payload.responseType,
          payload.url,
          payload.params,
          payload.hasOwnProperty("skipQueryParams")
        ),
        withOptionalSignal(
          payload,
          withAPIKeys({
            isAuthToken: payload.hasOwnProperty("isAuthToken")
              ? payload.isAuthToken
              : false,
          })
        )
      )
      .then((response) => response.data)
      .catch((error) => parseError(error)),
  post: (payload) =>
    axios
      .post(
        addPageNumber(
          payload.url,
          payload.params,
          payload.hasOwnProperty("skipQueryParams")
        ),
        payload.hasOwnProperty("bodyParams") && payload.bodyParams !== null
          ? { filter: payload.bodyParams }
          : payload.params,
        withOptionalSignal(
          payload,
          withAPIKeys({
            isAuthToken: payload.hasOwnProperty("isAuthToken")
              ? payload.isAuthToken
              : false,
          })
        )
      )
      .then((response) => response.data)
      .catch((error) => parseError(error)),
  getURLWithId: (payload) =>
    axios
      .get(
        addPageNumber(`${payload.url}${payload.params.pk}`, payload.params.pk),
        withOptionalSignal(
          payload,
          withAPIKeys({
            isAuthToken: payload.hasOwnProperty("isAuthToken")
              ? payload.isAuthToken
              : false,
          })
        )
      )
      .then((response) => response.data)
      .catch((error) => parseError(error)),
  postURLWithId: (payload) =>
    axios
      .post(
        addPageNumber(`${payload.url}${payload.params.id}`, payload.params.id),
        {},
        withOptionalSignal(
          payload,
          withAPIKeys({
            isAuthToken: payload.hasOwnProperty("isAuthToken")
              ? payload.isAuthToken
              : false,
          })
        )
      )
      .then((response) => response.data)
      .catch((error) => parseError(error)),
  put: (payload) =>
    axios
      .put(
        addPageNumber(
          payload.url,
          payload.params,
          payload.hasOwnProperty("skipQueryParams")
        ),
        payload.params,
        withOptionalSignal(
          payload,
          withAPIKeys({
            isAuthToken: payload.hasOwnProperty("isAuthToken")
              ? payload.isAuthToken
              : false,
          })
        )
      )
      .then((response) => response.data)
      .catch((error) => parseError(error)),
  patch: (payload) =>
    axios
      .patch(
        addPageNumber(payload.url, payload.params),
        payload.params,
        withOptionalSignal(
          payload,
          withAPIKeys({
            isAuthToken: payload.hasOwnProperty("isAuthToken")
              ? payload.isAuthToken
              : false,
          })
        )
      )
      .then((response) => response.data)
      .catch((error) => parseError(error)),
  delete: (payload) => {
    const config = withOptionalSignal(
      payload,
      withAPIKeys({
        isAuthToken: payload.hasOwnProperty("isAuthToken")
          ? payload.isAuthToken
          : false,
      })
    );
    
    // Support body data in delete requests
    if (payload.data) {
      config.data = payload.data;
    }
    
    return axios
      .delete(
        addPageNumber(payload.url, payload.params),
        config
      )
      .then((response) => {
        // if (response) {
        //   let user = JSON.parse(localStorage.getItem('user') as string);
        //   user.is_super_host = false;
        //   localStorage.setItem('user', JSON.stringify(user));
        // }
        return response?.data;
        // localStorage.removeItem('user');
        // localStorage.removeItem('accessToken');
      })
      .catch((error) => parseError(error));
  },
  postFormData: (payload) =>
    axios
      .post(
        payload.url,
        payload.params,
        withOptionalSignal(payload, withMultipartAPIKeys())
      )
      .then((response) => response.data)
      .catch((error) => parseError(error)),
};
